module.exports = __webpack_public_path__ + "img/team-towers.96425f13.jpg";